/**
 * An sms: deep link: opens the visitor's messaging app addressed to `number`
 * with `body` pre-filled (the live mission's "speak to your handler").
 */
export function smsHref(handlerNumber: string, body: string): string {
  return `sms:${handlerNumber}?&body=${encodeURIComponent(body)}`;
}
